<template>
    <a
        class="text-muval-gray-1 ring-brand relative flex cursor-pointer items-center text-sm font-normal underline underline-offset-2 outline-hidden hover:text-black"
    >
        <slot />
        <SvgIcon
            name="system-chevron-right"
            class="h-4 w-4"
        />
    </a>
</template>
